import React from 'react'
import './gridContainer.css'

class GridContainer extends React.PureComponent {
  render() {
    const {className, children} = this.props
    const classNames=['gridcontainer', className]
    return (
      <div className={classNames.join(' ')}>
        {children}
      </div>
    )
  }

}

export default GridContainer



// WEBPACK FOOTER //
// ./src/core/components/gridcontainer/GridContainer.js